import script from "./OrganizationMultiSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationMultiSelect.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationMultiSelect.vue?vue&type=style&index=0&id=ee3a3326&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee3a3326"]])

export default __exports__